import script from "./WatchlistImportReportModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchlistImportReportModal.vue?vue&type=script&setup=true&lang=ts"

import "./WatchlistImportReportModal.vue?vue&type=style&index=0&id=442bc88c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-442bc88c"]])

export default __exports__